module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "framework-content"
    }
  }, [_c('div', {
    staticClass: "content-position"
  }, [_vm._v("基本信息")]), _vm._v(" "), _c('div', {
    staticClass: "content-main"
  }, [_c('div', {
    staticClass: "account-info-bar"
  }, [_c('div', {
    staticClass: "detail-bar"
  }, [_c('span', {
    staticClass: "bar-title"
  }, [_vm._v("绑定手机")]), _vm._v(" "), (_vm.userInfo.mobile) ? _c('span', {
    staticClass: "bar-status"
  }, [_vm._v("已绑定手机号"), _c('b', [_vm._v(_vm._s(_vm.dealWithPhone))]), _vm._v("    可用此手机号登录")]) : _c('span', {
    staticClass: "bar-status"
  }, [_vm._v("未绑定手机号，绑定手机号可直接使用手机号登录")]), _vm._v(" "), _c('span', {
    staticClass: "bar-btn",
    class: {
      'bar-btn-active': _vm.aboutMobile.bindSatus
    },
    on: {
      "click": function($event) {
        _vm.aboutMobileBind()
      }
    }
  }, [(_vm.userInfo.mobile) ? _c('b', [_vm._v("更换")]) : _vm._e(), _vm._v("绑定手机号")])]), _vm._v(" "), _c('transition', {
    attrs: {
      "name": "info"
    }
  }, [(_vm.aboutMobile.bindSatus) ? _c('div', {
    staticClass: "detail-area"
  }, [_c('div', {
    staticClass: "detail-area-sub"
  }, [_c('p', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.userInfo.mobile),
      expression: "userInfo.mobile"
    }],
    staticClass: "form-item"
  }, [_c('label', [_vm._v("原手机号")]), _vm._v(" "), _c('input', {
    staticStyle: {
      "display": "none"
    },
    attrs: {
      "type": "text"
    }
  }), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.aboutMobile.oldNum),
      expression: "aboutMobile.oldNum"
    }],
    attrs: {
      "type": "text"
    },
    domProps: {
      "value": (_vm.aboutMobile.oldNum)
    },
    on: {
      "blur": _vm.checkOldMobile,
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.aboutMobile, "oldNum", $event.target.value)
      }
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "form-error-tips"
  }, [(_vm.rightIconControl.oldNum) ? _c('img', {
    attrs: {
      "src": require("../../assets/images/personal/right.png")
    }
  }) : _vm._e(), _vm._v(" "), (_vm.aboutMobile.oldNumTips) ? _c('img', {
    attrs: {
      "src": require("../../assets/images/personal/error.png")
    }
  }) : _vm._e(), _vm._v(" "), _c('b', [_vm._v(_vm._s(_vm.aboutMobile.oldNumTips))])])]), _vm._v(" "), _c('p', {
    staticClass: "form-item"
  }, [_c('label', [_c('b', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.userInfo.mobile),
      expression: "userInfo.mobile"
    }]
  }, [_vm._v("新")]), _vm._v("手机号")]), _vm._v(" "), _c('input', {
    staticStyle: {
      "display": "none"
    },
    attrs: {
      "type": "text"
    }
  }), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.aboutMobile.newNum),
      expression: "aboutMobile.newNum"
    }],
    attrs: {
      "type": "text"
    },
    domProps: {
      "value": (_vm.aboutMobile.newNum)
    },
    on: {
      "blur": _vm.checkNewMobile,
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.aboutMobile, "newNum", $event.target.value)
      }
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "form-error-tips"
  }, [(_vm.rightIconControl.newNum) ? _c('img', {
    attrs: {
      "src": require("../../assets/images/personal/right.png")
    }
  }) : _vm._e(), _vm._v(" "), (_vm.aboutMobile.newNumTips) ? _c('img', {
    attrs: {
      "src": require("../../assets/images/personal/error.png")
    }
  }) : _vm._e(), _vm._v(" "), _c('b', [_vm._v(_vm._s(_vm.aboutMobile.newNumTips))])])]), _vm._v(" "), _c('p', {
    staticClass: "form-item"
  }, [_c('label', [_vm._v("验证码")]), _vm._v(" "), _c('input', {
    staticStyle: {
      "display": "none"
    },
    attrs: {
      "type": "text"
    }
  }), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.aboutMobile.vcode),
      expression: "aboutMobile.vcode"
    }],
    staticClass: "form-vcode-input",
    attrs: {
      "type": "text"
    },
    domProps: {
      "value": (_vm.aboutMobile.vcode)
    },
    on: {
      "blur": _vm.checkCodeMobile,
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.aboutMobile, "vcode", $event.target.value)
      }
    }
  }), _vm._v(" "), _c('button', {
    staticClass: "form-btn form-vcode-btn",
    class: {
      sendMobileCodeActive: _vm.aboutMobile.getCodeIng
    },
    attrs: {
      "disabled": _vm.aboutMobile.getCodeIng
    },
    on: {
      "click": _vm.getVcode
    }
  }, [_vm._v("\n                " + _vm._s(_vm.aboutMobile.sendButtonCon) + "\n              ")]), _vm._v(" "), _c('span', {
    staticClass: "form-error-tips"
  }, [(!_vm.aboutMobile.vcodeTips && _vm.rightIconControl.vcode) ? _c('img', {
    attrs: {
      "src": require("../../assets/images/personal/right.png")
    }
  }) : _vm._e(), _vm._v(" "), (_vm.aboutMobile.vcodeTips) ? _c('img', {
    attrs: {
      "src": require("../../assets/images/personal/error.png")
    }
  }) : _vm._e(), _vm._v(" "), _c('b', [_vm._v(_vm._s(_vm.aboutMobile.vcodeTips))])])]), _vm._v(" "), _c('p', {
    staticClass: "form-item"
  }, [_c('button', {
    staticClass: "form-btn form-submit",
    on: {
      "click": _vm.bindMobileSubmit
    }
  }, [_vm._v("\n                绑定手机号\n              ")])])])]) : _vm._e()])], 1), _vm._v(" "), (!_vm.aboutMobile.bindSatus) ? _c('hr', {
    staticClass: "dashed-line"
  }) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "account-info-bar"
  }, [_c('div', {
    staticClass: "detail-bar"
  }, [_c('span', {
    staticClass: "bar-title"
  }, [_vm._v("绑定邮箱")]), _vm._v(" "), (_vm.userInfo.mail) ? _c('span', {
    staticClass: "bar-status"
  }, [_vm._v("已绑定邮箱"), _c('b', [_vm._v(_vm._s(_vm.userInfo.mail))]), _vm._v("    可用此邮箱登录")]) : _c('span', {
    staticClass: "bar-status"
  }, [_vm._v("未绑定邮箱，绑定邮箱可直接使用邮箱登录")]), _vm._v(" "), (!_vm.userInfo.mail) ? _c('span', {
    staticClass: "bar-btn",
    class: {
      'bar-btn-active': _vm.aboutEmail.bindSatus
    },
    on: {
      "click": _vm.aboutEmailBind
    }
  }, [_vm._v("绑定")]) : _vm._e()]), _vm._v(" "), _c('transition', {
    attrs: {
      "name": "info"
    }
  }, [(_vm.aboutEmail.bindSatus) ? _c('div', {
    staticClass: "detail-area"
  }, [_c('div', {
    staticClass: "detail-area-sub"
  }, [_c('p', {
    staticClass: "form-item"
  }, [_c('label', [_vm._v("邮箱")]), _vm._v(" "), _c('input', {
    staticStyle: {
      "display": "none"
    },
    attrs: {
      "type": "text"
    }
  }), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.aboutEmail.email),
      expression: "aboutEmail.email"
    }],
    attrs: {
      "type": "text"
    },
    domProps: {
      "value": (_vm.aboutEmail.email)
    },
    on: {
      "blur": _vm.checkEmail,
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.aboutEmail, "email", $event.target.value)
      }
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "form-error-tips"
  }, [(_vm.aboutEmail.emailTips) ? _c('img', {
    attrs: {
      "src": require("../../assets/images/personal/error.png")
    }
  }) : _vm._e(), _vm._v(" "), (_vm.rightIconControl.email) ? _c('img', {
    attrs: {
      "src": require("../../assets/images/personal/right.png")
    }
  }) : _vm._e(), _vm._v(" "), _c('b', [_vm._v(_vm._s(_vm.aboutEmail.emailTips))])])]), _vm._v(" "), _c('p', {
    staticClass: "form-item"
  }, [_c('button', {
    staticClass: "form-btn form-submit",
    on: {
      "click": _vm.bindEmailSubmit
    }
  }, [_vm._v("\n                绑定邮箱\n              ")])])])]) : _vm._e()])], 1), _vm._v(" "), (!_vm.aboutEmail.bindSatus) ? _c('hr', {
    staticClass: "dashed-line"
  }) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "detail-area-password"
  }, [_c('div', {
    staticClass: "detail-area-password-title"
  }, [_vm._v("修改密码")]), _vm._v(" "), _c('div', {
    staticClass: "detail-area-password-sub"
  }, [_c('p', {
    staticClass: "form-item"
  }, [_c('label', [_vm._v("当前密码")]), _vm._v(" "), _c('input', {
    staticStyle: {
      "display": "none"
    },
    attrs: {
      "type": "password"
    }
  }), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.passwords.currentPwd),
      expression: "passwords.currentPwd"
    }],
    staticClass: "current-pwd",
    attrs: {
      "type": "password",
      "autocomplete": "off"
    },
    domProps: {
      "value": (_vm.passwords.currentPwd)
    },
    on: {
      "blur": _vm.checkCurrentPwd,
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.passwords, "currentPwd", $event.target.value)
      }
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "form-error-tips"
  }, [(_vm.passwords.currentPwdTips) ? _c('img', {
    attrs: {
      "src": require("../../assets/images/personal/error.png")
    }
  }) : _vm._e(), _vm._v(" "), (_vm.rightIconControl.currentPwd) ? _c('img', {
    attrs: {
      "src": require("../../assets/images/personal/right.png")
    }
  }) : _vm._e(), _vm._v(" "), _c('b', [_vm._v(_vm._s(_vm.passwords.currentPwdTips))])])]), _vm._v(" "), _c('p', {
    staticClass: "form-item"
  }, [_c('label', [_vm._v("新密码")]), _vm._v(" "), _c('input', {
    staticStyle: {
      "display": "none"
    },
    attrs: {
      "type": "password"
    }
  }), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.passwords.newPwd),
      expression: "passwords.newPwd"
    }],
    staticClass: "new-pwd",
    attrs: {
      "type": "password",
      "autocomplete": "false"
    },
    domProps: {
      "value": (_vm.passwords.newPwd)
    },
    on: {
      "blur": _vm.checkNewPwd,
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.passwords, "newPwd", $event.target.value)
      }
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "form-error-tips"
  }, [(_vm.rightIconControl.newPwd) ? _c('img', {
    attrs: {
      "src": require("../../assets/images/personal/right.png")
    }
  }) : _vm._e(), _vm._v(" "), (_vm.passwords.newPwdTips) ? _c('img', {
    attrs: {
      "src": require("../../assets/images/personal/error.png")
    }
  }) : _vm._e(), _vm._v(" "), _c('b', [_vm._v(_vm._s(_vm.passwords.newPwdTips))])])]), _vm._v(" "), _c('p', {
    staticClass: "form-item"
  }, [_c('label', [_vm._v("确认密码")]), _vm._v(" "), _c('input', {
    staticStyle: {
      "display": "none"
    },
    attrs: {
      "type": "password"
    }
  }), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.passwords.confirmPwd),
      expression: "passwords.confirmPwd"
    }],
    staticClass: "confirm-pwd",
    attrs: {
      "type": "password",
      "autocomplete": "false"
    },
    domProps: {
      "value": (_vm.passwords.confirmPwd)
    },
    on: {
      "blur": _vm.checkConfirmPwd,
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.passwords, "confirmPwd", $event.target.value)
      }
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "form-error-tips"
  }, [(_vm.rightIconControl.confirmPwd) ? _c('img', {
    attrs: {
      "src": require("../../assets/images/personal/right.png")
    }
  }) : _vm._e(), _vm._v(" "), (_vm.passwords.confirmPwdTips) ? _c('img', {
    attrs: {
      "src": require("../../assets/images/personal/error.png")
    }
  }) : _vm._e(), _vm._v(" "), _c('b', [_vm._v(_vm._s(_vm.passwords.confirmPwdTips))])])]), _vm._v(" "), _c('p', {
    staticClass: "form-item"
  }, [_c('button', {
    staticClass: "form-submit form-btn",
    class: {
      isPwdSubmit: _vm.isPwdSubmit
    },
    on: {
      "click": _vm.pwdSubmit
    }
  }, [_vm._v("\n            提交\n          ")])])])])]), _vm._v(" "), _c('transition', {
    attrs: {
      "name": "fade"
    }
  }, [(_vm.isPopupE) ? _c('div', {
    staticClass: "success-tip-box"
  }, [_c('div', {
    staticClass: "bgshade-box",
    on: {
      "click": function($event) {
        _vm.hideWindow('isPopupE')
      }
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "con-box"
  }, [_c('p', {
    staticClass: "popupInfo"
  }, [_vm._v("绑定邮箱成功 !")]), _vm._v(" "), _c('img', {
    attrs: {
      "src": require("../../assets/personal/success.png")
    }
  }), _vm._v(" "), _c('span', {
    on: {
      "click": _vm.startSearch
    }
  }, [_vm._v("开始搜索")])])]) : _vm._e()]), _vm._v(" "), _c('transition', {
    attrs: {
      "name": "fade"
    }
  }, [(_vm.isPopupM) ? _c('div', {
    staticClass: "success-tip-box"
  }, [_c('div', {
    staticClass: "bgshade-box",
    on: {
      "click": function($event) {
        _vm.hideWindow('isPopupM')
      }
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "con-box"
  }, [_c('p', {
    staticClass: "popupInfo"
  }, [_vm._v("绑定手机成功 !")]), _vm._v(" "), _c('img', {
    attrs: {
      "src": require("../../assets/personal/success.png")
    }
  }), _vm._v(" "), _c('span', {
    on: {
      "click": _vm.startSearch
    }
  }, [_vm._v("开始搜索")])])]) : _vm._e()])], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-6afdf82e"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/personal/AccountInfo.vue
// module id = 771
// module chunks = 1